import styled from '@emotion/styled';
import User from '../../../entity/User';
import { Avatar as _Avatar, Typography } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import { createElement, FC } from 'react';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';
import { ThemeStyle } from '@material-ui/core/styles/createTypography';

interface Props {
  user: User;
  size?: number;
  variant?: ThemeStyle;
  className?: string;
  isHorizontal?: boolean;
}

const AvatarAndName: FC<Props> = ({ user, size = 24, variant = 'body1', className, isHorizontal }) => {
  const avatarStyle = {
    width: size,
    height: size,
    marginBottom: size / 100,
  };
  const rootStyle = gridLayoutContainer({
    columns: isHorizontal ? ['auto', '8px', 'auto'] : ['auto'],
    rows: isHorizontal ? ['auto'] : ['auto', 'auto'],
    areas: isHorizontal ? [['avatar', 'auto', 'name']] : [['avatar'], ['name']],
  });
  const avatar = user.profileImageUrl ? (
    <Avatar src={user.profileImageUrl} alt={user.name} style={avatarStyle} />
  ) : (
    <AccountCircle style={avatarStyle} color="action" />
  );
  return (
    <Root className={className} style={rootStyle}>
      {avatar}
      <Name variant={variant}>{user.name}</Name>
    </Root>
  );
};

const Root = styled('div')({
  justifyItems: 'center',
});

const Avatar = styled(_Avatar)(gridLayoutItem('avatar')) as typeof _Avatar;

const Name = styled(Typography)(gridLayoutItem('name', { alignSelf: 'center' }), {
  fontWeight: 'bold',
  wordBreak: 'break-all',
}) as typeof Typography;

export default AvatarAndName;
